import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam } from 'src/app/shared/models/Global-Search.model';
import { VendorClientAssignmentService } from '../../../services';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { VendorClientAssignment } from '../../../models';
import { SharedService } from '../../../../shared/services/shared.service';
import { Router, ActivatedRoute,NavigationStart } from '@angular/router';
import {ClientApprovalService} from'../../../services/client-approval.service';
import { IClientApprovalNotes } from 'src/app/admin/models';
import * as fs from 'file-saver';
import { JwtService } from 'src/app/auth/services';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-client-approval-search',
  templateUrl: './client-approval-search.component.html',
  styleUrls: ['./client-approval-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class ClientApprovalSearchComponent implements OnInit {
  isSearchLoading: boolean = false;
  showFilters:boolean;
  showSorting:boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  matchModeOptionsForDropdown: SelectItem[];
  showAddRuleButtonCON:boolean = false;
  showAddRuleButtonMON:boolean = false;
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  searchParam:IGlobalSearchParam;
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  vcaSearchSpinner = 'vcaSearchSpinner';
  clientApprovalList: any;
  startSearch: boolean = false;
  dialogPosition = 'topright';
  isVcaAdd : boolean = false;
  vcaForm:FormGroup;
  vendorCompanyList: any;
  clientCompanyList: any;
  loading: boolean = false;
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  showToggle:boolean;
  isshowpaginator:boolean=true;
  statusValues:any;
  selectedStatusId:any="All";
  selectedStatus:any;
  displayModal:boolean = false;
  displayNotesHistoryModal:boolean =false;
  displayNotesDescriptionModal:boolean = false; 
  notesList;
  assignId;
  companyId;
  clientId;
  notesFormControl = new FormControl("",[Validators.required, this.editorMaxLength(5000)]);
  clientApprovalStatus: ILookupCategory;
  selectedApprovalStatus:any;
  public selectedApprovalStatusId:Array<any> = [];
  arrApprovalStatus:any;
  approvalStatusId: any;
  itemsForReject: MenuItem[];
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'vendorCompanyName', header: 'Vendor Company Name' },
    { value: 'clientCompanyName', header: 'Client Company Name' },
    { value: 'approvalStatus', header: 'Status' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedBy', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' }  
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'vendorCompanyName', header: 'Vendor Company Name' },
    { value: 'clientCompanyName', header: 'Client Company Name' },
    { value: 'approvalStatus', header: 'Status' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedBy', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modified On' }  
  ]
  @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private vendorClientAssignmentService:VendorClientAssignmentService,
    private clientApprovalService:ClientApprovalService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router,
    private jwtService:JwtService,
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
    //setInterval(() =>  this.checkSessionTimeout(), 60000);
    // _router.events.forEach((event) => {
    //   if (event instanceof NavigationStart) {
    //      if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
    //      // this.show = false;
    //      }
    //      else {
    //       var isTokenAvailable = this.sharedService.isTokenAvailable();
         
    //       if(isTokenAvailable){
    //       setInterval(() =>  this.checkSessionTimeout(), 60000);
    //       }
        
    //      }
    //     }
    // });
    this.items = [
      {
       label:'Reject',
       icon:'pi pi-fw pi-times',
       command: e => this.rejectClient(this.selectedGridMenuItem.assignId,this.selectedGridMenuItem.vendorCompanyId)
      },
      {
       label:'Approve',
       icon:'pi pi-fw pi-check',
       command: e => this.approveClient(this.selectedGridMenuItem.assignId,this.selectedGridMenuItem.vendorCompanyId)
      },
      {
        label:'Notes History',
        icon:'pi pi-comments',
        command: e => this.notesHistory(e)
       },
    
  ];

  this.itemsForReject=[
    {
      label:'Approve',
      icon:'pi pi-fw pi-check',
      command: e => this.approveClient(this.selectedGridMenuItem.assignId,this.selectedGridMenuItem.vendorCompanyId)
     },
     {
       label:'Notes History',
       icon:'pi pi-comments',
       command: e => this.notesHistory(e)
      },
  ];
  }
  checkSessionTimeout()
  {

    var isTokenAvailable = this.sharedService.isTokenAvailable();
    if(isTokenAvailable){
      var result = this.sharedService.checkSessionTimeout();
     // console.log('Session' + result);
       if(!result) {
         localStorage.removeItem('VMS');
         this._router.navigateByUrl('/login');
       }
    } 
   
  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.getApprovalStatus();
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];
    this.matchModeOptionsForDropdown = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
    ];

    this.filterCondition=[
      {fieldName:"vendorCompanyName",type:"basic"},
      {fieldName:"clientCompanyName",type:"basic"},
      {fieldName:"approvalStatus",type:"dropdown"},
      {fieldName:"createdBy",type:"basic"},
      {fieldName:"createdOn",type:"date"},
      {fieldName:"modifiedBy",type:"basic"},
      {fieldName:"modifiedOn",type:"date"},
    ];

    this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" });
    this.getVendorClientApproval(); 
  }

  

  loadClientApproval(event:LazyLoadEvent)
  { console.log(event);
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getVendorClientApproval();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;

    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonCON = true;
    }
    else{
      this.showAddRuleButtonCON = false;
    }
    }
    if(this.filters["modifiedOn"]!= undefined)
    {
    if(this.filters["modifiedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonMON = true;
    }
    else{
      this.showAddRuleButtonMON = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    /*if(this.sortField !== 'createdOn')
    {
      this.getAllClaimsMasterList()
    }*/

    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getVendorClientApproval()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }

  getVendorClientApproval(){
    this.searchParam = 
    {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
    };
    this.spinner.show(this.vcaSearchSpinner);
    this.clientApprovalService.getAllClientApprovalList(this.searchParam).subscribe(data => {
      console.log(data);
      this.appliedFilters = [];
      this.clientApprovalList =data;
      this.isshowpaginator=this.clientApprovalList.length>0?true:false;
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.vcaSearchSpinner);
    }, error => {
      console.log(error);
    })
  }

  
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.selectedApprovalStatus ="";
    this.selectedApprovalStatusId = undefined;
    // this.applyFilter();
    this.getVendorClientApproval(); 
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter(){
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
              if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                })
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              if(this.filterCondition[i].fieldName != "All")
              {
                this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value.lookupOrder
              })}
            }
          }
        }
    }
    }

    if(this.startSearch == true || this.startSearch == false)
    {
      this.searchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.vcaSearchSpinner);
       this.clientApprovalService.getAllClientApprovalList(this.searchParam).subscribe(data => {
         console.log(data);
         this.appliedFilters = [];
         this.clientApprovalList =data;
         this.isshowpaginator=this.clientApprovalList.length>0?true:false;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.vcaSearchSpinner);
       }, error => {
         console.log(error);
       })
    }
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }
 getApprovalStatus() {
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.ClientApprovalStatus).subscribe((data: any) => {
  this.clientApprovalStatus = data;
  this.arrApprovalStatus = this.clientApprovalStatus;
  this.arrApprovalStatus.push({categoryId:0,createdBy:0,createdByUser:null,createdOn: null,description:"All",isActive: true,
  lookupCategory: null,
  lookupId: 0,
  lookupOrder: 0,
  modifiedBy: 0,
  modifiedByUser: null,
  modifiedOn: null});
  this.arrApprovalStatus.sort((a, b) => (a.description < b.description) ? -1 : 1);
  this.clientApprovalStatus = this.arrApprovalStatus;
});
}

getApprovalStatusOnChange(event)
{
this.selectedApprovalStatus = event.value.description;
if(event.value.description  != 'All')
{
  this.approvalStatusId = event.value.lookupOrder;
  this.clientApprovalService.getApprovalStatus(event.value.lookupOrder).subscribe((data:any) =>{
    this.selectedApprovalStatusId = data;
  });
}
}
clearApprovalStatus()
{
this.selectedApprovalStatus ="";
this.selectedApprovalStatusId = undefined;
}
 approveClient(assignId:number,companyId:number) {
  var loggedInUser = this.jwtService.getLoggedInUserProfileId();
  this.confirmationService.confirm({
      message: 'Are you sure that you want to Approve this Client?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
          this.messageService.add({severity:'success', summary:'Confirmed', detail:'Client Approved'});
          this.clientApprovalService.approveClient(assignId,loggedInUser).subscribe((data:any) =>{
            setTimeout(() => {
              this.getVendorClientApproval();
                     
          }, 3000);
          });
      },
      reject: (type) => {
          switch(type) {
              case ConfirmEventType.REJECT:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
              case ConfirmEventType.CANCEL:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
          }
      }
  });
}
rejectClient(assignId:number,companyId:number) {
  this.confirmationService.confirm({
      message: 'Are you sure that you want to Reject this Client for the Vendor?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayModal = true;
         this.assignId =assignId;
         this.companyId = companyId;
       //// this.clientApprovalService.GetClientApprovalNotes(this.assignId).subscribe((data:any)=>{
          //this.notesList = data;
        //});
          
      },
      reject: (type) => {
          switch(type) {
              case ConfirmEventType.REJECT:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
              case ConfirmEventType.CANCEL:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
          }
      }
  });
}
editorMaxLength(maxlength): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    var regex = /(<([^>]+)>)/ig;
    var value = control.value;
    if (value == null) {
      return null;
    }
    var result = value.replace(regex, "");
    if (result.length > maxlength) {
      return { 'maxlengthError': true };
    } else {
      return null;
    }
  }
}
notesHistory(event)
{
  this.displayNotesHistoryModal = true;
  this.assignId =this.selectedGridMenuItem.assignId;
  this.companyId =this.selectedGridMenuItem.vendorCompanyId;
  this.clientId =this.selectedGridMenuItem.clientCompanyId;
   this.clientApprovalService.GetClientNotes(this.assignId,this.companyId,this.clientId).subscribe((data:any)=>{
     console.log(data);
     for(let i=0;i<data.length;i++)
     {
      data[i].description = data[i].description.replace(/<[^>]+>/g, '');
     }
        this.notesList = data;
      });
      console.log( this.notesList);
}
updateClientNotes() {
  var loggedInUser = this.jwtService.getLoggedInUserProfileId();
 // this.notes = this.notesFormControl.value;
  const clientNotes:IClientApprovalNotes={
    description: this.notesFormControl.value,
    companyId: this.companyId,
    assignId:this.assignId,
    createdBy: this.jwtService.getLoggedInUserProfileId(),
    createdOn: new Date(),
    modifiedBy: this.jwtService.getLoggedInUserProfileId(),
    modifiedOn: new Date(),
    notesId: 0
  }
  
  this.notesFormControl.setValue('');
  this.messageService.add({severity:'success', summary:'Confirmed', detail:'Client Rejected'});
  this.clientApprovalService.rejectClient(this.assignId,loggedInUser).subscribe((data:any) =>{
    setTimeout(() => {
      this.getVendorClientApproval();
              this.clientApprovalService.updateClientNotes(clientNotes).subscribe((data:any) =>{
               
              });
  }, 3000);
            
   })
}
cancelNotes()
{
  //this.notes='';
  this.notesFormControl.setValue('');
}
closeNotes(){
  this.cancelNotes()
}
}
